module.exports = __webpack_public_path__ + "img/tree-03-e-leaves.dfc5d822.png";